import { AuthSession } from '@aws-amplify/auth';

/**
 * This interface defines the structure of the authentication state used in the application. It includes properties for the username, role, authentication status, loading state, error messages, and the AWS Amplify authentication session.
 *  - username: The username of the authenticated user, or null if not authenticated.
 *  - role: The role of the authenticated user, or null if not authenticated.
 *  - isAuthenticated: A boolean indicating whether the user is currently authenticated.
 *  - loadingLogging: A boolean indicating whether a login operation is currently in progress.
 *  - error: A string containing any error messages related to authentication, or null if there are no errors.
 *  - amplifySession: The AWS Amplify authentication session object, or null if not authenticated.
 */
interface AuthState {
    username: string ;
    role: string ;
    isAuthenticated: boolean;
    loadingLogging: boolean;
    error: string | null;
    amplifySession: AuthSession | null;
}


export const initialAuthState: AuthState = {
    username: '',
    role: '',
    isAuthenticated: false,
    loadingLogging: false,
    error: null,
    amplifySession: null,
}
